import React from 'react'

export default function Warning(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 9 9"
      stroke="currentColor"
      className={`text-red-600 ${props.className}`}
      {...props}
    >
      <path
        d="M4.50351 3.33692V4.89127M4.50351 6.44562H4.507M7.90629 6.83421L5.10852 1.39399C5.04752 1.27438 4.95905 1.1749 4.85215 1.10568C4.74525 1.03647 4.62374 1 4.50001 1C4.37628 1 4.25477 1.03647 4.14787 1.10568C4.04096 1.1749 3.9525 1.27438 3.89149 1.39399L1.09372 6.83421C1.03206 6.95287 0.999729 7.08753 1 7.22455C1.00027 7.36156 1.03314 7.49607 1.09528 7.61442C1.15741 7.73278 1.2466 7.83077 1.35381 7.89848C1.46102 7.96619 1.58243 8.0012 1.70574 7.99997H7.30127C7.42399 7.99983 7.54452 7.96382 7.65074 7.89555C7.75697 7.82728 7.84517 7.72916 7.90647 7.61104C7.96778 7.49292 8.00003 7.35895 8 7.22259C7.99997 7.08624 7.96765 6.95229 7.90629 6.83421Z"
        stroke="#EB5757"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
